<!-- 外卖菜品页面 -->
<template>
  <div class="home flexBox" v-if="isAll">
    <van-nav-bar
      :title="$t('Dishes.title')"
      left-arrow
      fixed
      @click-left="
        $router.push(
          '/Home/' + sessionStorage.storeId + '/book/' + sessionStorage.code
        )
      "
    ></van-nav-bar>
    <div class="contentWrapper">
      <div v-if="dishes" class="menuContent">
        <van-sidebar v-model="activeKey" @change="changeKey()">
          <div v-for="(dish, index) in dishes" :key="index">
            <van-sidebar-item
              v-if="dish.status"
              :title="dish.name"
            ></van-sidebar-item>
          </div>
        </van-sidebar>
        <div class="dishContent">
          <!-- 有产品 -->
          <template v-if="actMenus.length > 0">
            <div
              v-for="(menu, index) in actMenus"
              class="dishItem"
              :key="menu.id"
            >
              <div
                @click.stop="
                  menu.category == 'm'
                    ? $router.push('/TakeDishDetail/' + menu.id)
                    : $router.push('/TakePackageDetail/' + menu.id)
                "
              >
                <template v-if="menu.image">
                  <van-image
                    class="noflex"
                    width="90px"
                    height="90px"
                    style="margin-top: 5px; margin-left: 5px;"
                    fit="contain"
                    :src="menu.image.path"
                  />
                </template>
                <template v-else>
                  <van-image
                    class="noflex"
                    width="90px"
                    height="90px"
                    style="margin-top: 5px; margin-left: 5px;"
                    fit="contain"
                    :src="sessionStorage.images"
                  />
                </template>
              </div>
              <div class="itemInfo">
                <div
                  class="leftInfo"
                  @click.stop="
                    menu.category == 'm'
                      ? $router.push('/TakeDishDetail/' + menu.id)
                      : $router.push('/TakePackageDetail/' + menu.id)
                  "
                >
                  <div class="fontLine noExceed">{{ menu.name }}</div>
                  <div class="fontLine noExceed">{{ menu.name_en }}</div>
                  <div style="height: 5px;"></div>
                  <!-- <van-rate
                    readonly
                    v-model="menu.level"
                    :size="12"
                    gutter="1px"
                    icon="./static/img/Recommend-s.png"
                    void-icon="./static/img/Recommend.png"
                  /> -->
                  <div class="fontLine noExceed price_num">
                    <div
                      v-if="menu.original_price || menu.special_price !== null"
                    >
                      <span class="currentPrice">
                        {{ sessionStorage.getItem("currency")
                        }}{{
                          menu.type == "o"
                            ? menu.original_price
                            : menu.special_price
                        }}
                      </span>
                      &nbsp;
                      <span class="oldPrice" v-show="menu.type == 's'">
                        {{ sessionStorage.getItem("currency")
                        }}{{ menu.original_price }}
                      </span>
                    </div>
                    <div v-else>{{ sessionStorage.getItem("currency") }}0</div>
                  </div>
                </div>
                <div
                  class="icons"
                  v-if="sessionStorage.getItem('is_quick') == '1'"
                >
                  <van-stepper
                    default-value="0"
                    min="0"
                    integer
                    v-model="menu.count"
                    theme="round"
                    button-size="22"
                    @plus="addDish(menu.id, index, 1)"
                    @minus="subDish(menu.id, index, 1)"
                    @focus="focusDish($event, menu.id, index, menu.count)"
                    @blur="blurDish(menu.id, index, menu.count)"
                    ref="input"
                    allow-empty
                  />
                </div>
                <div
                  class="enterIcon"
                  @click.stop="
                    menu.category == 'm'
                      ? $router.push('/TakeDishDetail/' + menu.id)
                      : $router.push('/TakePackageDetail/' + menu.id)
                  "
                >
                  <van-icon name="./static/img/View_orders.png" size="16px" />
                </div>
              </div>
            </div>
          </template>
          <!-- 没产品 -->
          <template v-else>
            <div style="text-align: center; line-height: 80px;">
              {{ $t("Dishes.nonefood") }}
            </div>
          </template>
        </div>
      </div>
      <!-- 购物车菜品 -->
      <van-popup
        v-model="isShopCartShow"
        position="bottom"
        :style="{ height: '75%' }"
      >
        <van-cell-group>
          <van-cell>
            <div style="font-size: 16px;" slot="title">
              {{ $t("Dishes.cart") }}
            </div>
            <van-icon
              slot="right-icon"
              name="./static/img/dele_staff.png"
              size="26px"
              @click="isShopCartShow = false"
            />
          </van-cell>
        </van-cell-group>
        <div class="cartDetail" v-if="shopCart.data">
          <template v-for="(dish, index) in shopCart.data">
            <div class="cartItem" :key="index">
              <!-- 单品 -->
              <div class="cart_dish">
                <div class="cart_dish_name noExceed fl">
                  <template v-if="dish.image">
                    <van-image
                      class="menuImg fl"
                      width="50"
                      height="50"
                      fit="contain"
                      :src="dish.image.path"
                    />
                  </template>
                  <template v-else>
                    <van-image
                      class="menuImg"
                      width="50"
                      height="50"
                      fit="contain"
                      :src="sessionStorage.images"
                    />
                  </template>
                  {{ dish.menu_name }}
                </div>
                <div v-if="dish.menus_name" class="cart_dish_price noExceed fl">
                  {{ sessionStorage.getItem("currency")
                  }}{{ dish.original_price / dish.number }}
                </div>
                <div class="cart_dish_des noExceed fl">
                  <template
                    v-if="dish.menus_name.length == 0 && dish.tags_name"
                  >
                    <span
                      v-for="(tagName, index) in dish.tags_name"
                      :key="index"
                    >
                      {{ tagName }}
                    </span>
                  </template>
                  <span
                    v-if="dish.menus_name.length == 0 && dish.remark[0] != ''"
                    >{{ $t("PackageDetail.remark") }}：</span
                  >
                  <template
                    v-if="dish.menus_name.length == 0 && dish.remark[0] != ''"
                  >
                    ({{ dish.remark[0] }})
                  </template>
                </div>
              </div>
              <!-- 套餐 -->
              <div v-if="dish.menus_name">
                <div
                  class="cart_dish son_dish"
                  v-for="(menu, key) in dish.menus_name"
                  :key="key"
                >
                  <div
                    v-if="typeof menu == 'object'"
                    class="cart_dish_name noExceed fl"
                  >
                    <template v-for="(menuArr, i) in menu">
                      {{ menuArr }}{{ i == menu.length - 1 ? "" : "、" }}
                    </template>
                  </div>
                  <div v-else class="cart_dish_name noExceed fl">
                    {{ menu }}
                  </div>

                  <div
                    v-if="typeof menu == 'object'"
                    class="cart_dish_price noExceed fl"
                  >
                    {{ sessionStorage.getItem("currency") }}
                    <template v-for="(priceArr, j) in dish.fill_price[key]">
                      {{ j == 0 ? priceTotal(dish.fill_price[key]) : "" }}
                    </template>
                  </div>
                  <div v-else class="cart_dish_price noExceed fl">
                    {{ sessionStorage.getItem("currency")
                    }}{{ dish.fill_price[key] }}
                  </div>
                  <div class="cart_dish_des noExceed fl">
                    <template v-if="dish.tags_name[key]">
                      <template v-if="typeof dish.tags_name[key] == 'object'">
                        <template v-for="(tagName, i) in dish.tags_name[key]">
                          <template v-if="typeof tagName == 'object'">
                            {{ arrShow(tagName) }}
                          </template>
                          <template v-else>
                            {{ tagName }}
                          </template>
                          <template v-if="dish.remark[key][i]">
                            ({{ dish.remark[key][i]
                            }}{{
                              i == dish.remark[key].length - 1 ||
                              !dish.remark[key][i]
                                ? ""
                                : ""
                            }})
                          </template>
                          &nbsp;&nbsp;
                        </template>
                      </template>
                      <template v-else>
                        {{ dish.tags_name[key] }}
                        <template v-if="dish.remark[key]">
                          ({{ dish.remark[key] }})
                        </template>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
              <!-- 加减和价格 -->
              <div class="icon_group">
                <div class="cart_dish_icon fl">
                  <van-icon
                    name="./static/img/Return_number.png"
                    size="30px"
                    @click="subShopCart(dish.id, dish.number)"
                  ></van-icon>
                  <span
                    style="
                      display: inline-block;
                      min-width: 30px;
                      height: 30px;
                      text-align: center;
                      line-height: 30px;
                      padding: 5px 0;
                      vertical-align: top;
                    "
                  >
                    {{ dish.number }}
                  </span>
                  <van-icon
                    name="./static/img/add_food.png"
                    size="30px"
                    @click="addShopCart(dish.id)"
                  ></van-icon>
                </div>
                <div class="cart_dish_price fl realPrice">
                  {{ sessionStorage.getItem("currency") }}{{ dish.price }}
                </div>
              </div>
            </div>
            <van-divider style="margin: 10px 0;" />
          </template>

          <div style="height: 50px;"></div>
        </div>
        <van-tabbar class="flexNone" style="background: #000;">
          <div style="width: 88%; height: 34px; margin: 8px 6%;">
            <div class="cart_left">
              <div class="fl total_price" style="text-indent: 0;">
                {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
              </div>
            </div>
            <div class="cart_right">
              <!-- 弹框中的下单按钮 -->
              <van-button
                color="#2f75f4"
                class="cart_right_btn"
                round
                @click="cook()"
              >
                {{ $t("Dishes.order") }}
              </van-button>
            </div>
          </div>
        </van-tabbar>
      </van-popup>
      <van-tabbar :fixed="true" style="background: #000;">
        <div style="width: 88%; height: 34px; margin: 8px 6%;">
          <div class="cart_left">
            <van-icon
              class="fl"
              name="./static/img/Shopping_cart.png"
              :badge="shopCart.count"
              @click="isShopCartShow = true"
              size="34px"
            />
            <div class="fl total_price">
              {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
            </div>
          </div>
          <div class="cart_right">
            <!-- 下单按钮 -->
            <van-button
              color="#2f75f4"
              class="cart_right_btn"
              round
              @click="cook()"
            >
              {{ $t("Dishes.order") }}
            </van-button>
          </div>
        </div>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dishes: [],
      activeKey: 0,
      actMenus: [],
      isAll: false,
      isShopCartShow: false,
      shopCart: {},
      count: 4
    };
  },
  mounted() {
    this.getShopInfo();
    this.getShopCart();
    this.getDishes();
    // this.shopNumber()
    this.$i18n.locale = sessionStorage.locale;
    // console.log(this.$i18n.locale, "当前语言");
  },
  computed: {
    priceTotal() {
      return function(arr) {
        var sum = 0;
        for (var i in arr) {
          sum += Number(arr[i]);
        }
        return sum;
      };
    },
    arrShow() {
      return function(arr) {
        var str = "";
        for (var i in arr) {
          str += arr[i] + (i == arr.length - 1 || !arr[i] ? "" : ",");
        }
        return str;
      };
    }
  },
  methods: {
    //获取店铺信息
    getShopInfo() {
      this.$axios({
        method: "get",
        headers: {
          code: sessionStorage.code
        },
        url:
          this.$build + "/api/store/" + sessionStorage.storeId + "/customerShow"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            sessionStorage.setItem("currency", res.data.data.currency.unit);
            sessionStorage.setItem("is_quick", res.data.data.is_quick);
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$toast({
          //   type: "fail",
          //   message: this.$t("common.message")
          // });
        });
    },
    // 获取全部菜品
    getDishes() {
      this.$axios({
        method: "get",
        url:
          this.$build + "/api/store/" + sessionStorage.storeId + "/takeMenus/in"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            let dishes = [];
            res.data.data.forEach(item => {
              if (item.status == 1) {
                dishes.push(item);
              }
            });
            this.dishes = dishes;
            this.actMenus = this.dishes[this.activeKey].menus;
            if (this.shopCart.data) {
              this.actMenus.forEach(menu => {
                this.shopCart.data.forEach(shop => {
                  if (menu.id === shop.menu_id) {
                    menu.count = shop.number;
                  }
                });
              });
            }
            this.isAll = true;
            // this.getShopCart();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$toast({
          //   type: "fail",
          //   message: this.$t("common.message")
          // });
        });
    },
    // 切换选中栏
    changeKey() {
      this.actMenus = this.dishes[this.activeKey].menus;
      sessionStorage.setItem("activeKey", this.activeKey);
    },
    // 保存上次选择的tab栏选项
    getActiveKey() {
      // console.log(sessionStorage.getItem("activeKey"));
      if (sessionStorage.getItem("activeKey")) {
        this.activeKey = Number(sessionStorage.getItem("activeKey"));
      } else {
        this.activeKey = 0;
      }
    },
    // 获取购物车
    getShopCart() {
      this.$axios({
        method: "post",
        url: this.$build + "/api/place/takeShopcart",
        data: {
          code: localStorage.getItem("onlyCode")
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.shopCart = res.data;
            this.shopCart.data.forEach(item => {
              let arr = [];
              if (item.menus_name.length != 0 && item.tags_name) {
                // 套餐偏好重新排版
                item.tags_name.forEach((i, num) => {
                  i.forEach((j, index) => {
                    let list = []; //临时存储
                    if (i.length > 1) {
                      list.push(`(${item.menus_name[num][index]})：`);
                    }
                    if (typeof j == "object") {
                      j.forEach(tag => {
                        list.push(tag);
                      });
                    } else {
                      list.push(j);
                    }
                    i.splice(index, 1, list);
                  });
                });
              } else if (item.menus_name.length == 0 && item.tags_name) {
                // 单品偏好重新排版
                if (item.tags_name[0] != "") {
                  item.tags_name.forEach(i => {
                    i.forEach(j => {
                      if (typeof j == "object") {
                        j.forEach(tag => {
                          arr.push(tag);
                        });
                      } else {
                        arr.push(j);
                      }
                    });
                  });
                }
                item.tags_name = arr;
              }
            });
          } else {
            // 购物车为空提示
            // for (var item in res.data.error) {
            //   this.$toast({
            //     duration: 1000,
            //     type: "fail",
            //     message: res.data.error[item]
            //   });
            // }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$toast({
          //   duration: 1000,
          //   type: "fail",
          //   message: this.$t("common.message")
          // });
        });
    },
    // 增加商品
    addShopCart(id) {
      this.$axios({
        method: "PATCH",
        url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
        data: {
          type: "add"
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$toast({
          //   duration: 1000,
          //   type: "fail",
          //   message: this.$t("common.message")
          // });
        });
    },
    // 减少商品
    subShopCart(id, number) {
      if (number == 1) {
        this.$dialog
          .confirm({
            title: this.$t("Dishes.del"),
            message: this.$t("Dishes.isDel"),
            confirmButtonColor: "#FFC813",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "PATCH",
              url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
              data: {
                type: "reduce"
              }
            })
              .then(res => {
                // console.log(res);
                if (res.data.status == 200) {
                  this.getShopCart();
                  this.getDishes();
                } else {
                  this.$toast.allowMultiple();
                  for (var item in res.data.error) {
                    this.$toast({
                      duration: 1000,
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                console.log(err);
                // this.$toast({
                //   duration: 1000,
                //   type: "fail",
                //   message: this.$t("common.message")
                // });
              });
          })
          .catch(() => {});
      } else {
        this.$axios({
          method: "PATCH",
          url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
          data: {
            type: "reduce"
          }
        })
          .then(res => {
            // console.log(res);
            if (res.data.status == 200) {
              this.getShopCart();
              this.getDishes();
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  duration: 1000,
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            console.log(err);
            // this.$toast({
            //   duration: 1000,
            //   type: "fail",
            //   message: this.$t("common.message")
            // });
          });
      }
    },
    // 下单
    cook() {
      if (this.shopCart.count >= 1) {
        // this.$router.push('/Address');
        this.$router.push("/TakeCartDetail");
      } else {
        this.$toast("购物车为空");
      }
    },
    prepend(arr, item) {
      var m = [item];
      [].push.apply(m, arr);
      return m;
    },
    addDish(id, index, number) {
      this.$axios({
        method: "POST",
        url: this.$build + "/api/shopcart/takeCreated",
        data: {
          code: localStorage.getItem("onlyCode"),
          menu_id: id,
          number
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
            // this.actMenus[index].count = this.actMenus[index].count + 1;
            this.$toast({
              type: "success",
              message: res.data.message,
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$toast({
          //   duration: 1000,
          //   type: "fail",
          //   message: this.$t("common.message")
          // });
        });
    },
    subDish(id, index, number) {
      this.$axios({
        method: "POST",
        url: this.$build + "/api/shopcart/takeReduced",
        data: {
          code: localStorage.getItem("onlyCode"),
          menu_id: id,
          number: number
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
            // this.actMenus[index].count = this.actMenus[index].count - 1;
            this.$toast({
              type: "success",
              message: res.data.message,
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
            // for (var item in res.data.error) {
            //   this.$toast({
            //     duration: 1000,
            //     type: "fail",
            //     message: res.data.error[item]
            //   });
            // }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$toast({
          //   duration: 1000,
          //   type: "fail",
          //   message: this.$t("common.message")
          // });
        });
    },
    // 输入框聚焦时触发
    focusDish(e, id, index, count) {
      // this.actMenus[index].count = "";
      let obj = e.srcElement;
      obj.focus();
      const len = obj.value.length;
      //光标定位要加上 setTimeOut，不然就会重新光标定位失败
      setTimeout(() => {
        obj.selectionStart = obj.selectionEnd = len;
      }, 60);
    },
    // 输入框失焦时触发
    blurDish(id, index, count) {
      console.log("失焦");
      let beforeCount = 0;
      if (this.shopCart.data) {
        this.shopCart.data.forEach(i => {
          if (i.menu_id == id) {
            beforeCount = i.number;
          }
        });
      }
      if (count > 0) {
        if (beforeCount > count) {
          this.subDish(id, index, beforeCount - count);
        } else if (beforeCount < count) {
          this.addDish(id, index, count - beforeCount);
        } else {
          return;
        }
      } else if (count == 0) {
        this.actMenus[index].count = 0;
        this.subDish(id, index, beforeCount - 1);
        this.subDish(id, index, 1);
      } else {
        this.shopNumber();
      }
    },
    isInShopCart(id) {
      var val = 0;
      if (this.shopCart.data) {
        for (var i = 0; i < this.shopCart.data.length; i++) {
          if (id == this.shopCart.data[i].menu_id) {
            val += this.shopCart.data[i].number;
          }
        }
      }
      return val;
    },
    editPackage(cartMenu) {
      if (cartMenu.category == "m") {
      } else {
        var data = {
          menu_id: cartMenu.menu_id,
          menus_id: cartMenu.menus_id,
          tags_id: cartMenu.tags_id,
          fill_price: cartMenu.fill_price,
          remark: cartMenu.remark
        };
        sessionStorage.setItem("editPackage", JSON.stringify(data));
        this.$router.push("/PackageEdit/" + cartMenu.id);
      }
    },
    shopNumber() {
      console.log(this.shopCart.data);
      if (this.shopCart.data) {
        this.actMenus.forEach(menu => {
          this.shopCart.data.forEach(shop => {
            if (menu.id === shop.menu_id) {
              menu.count = shop.number;
            }
          });
        });
      }
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-sidebar {
  /*width: 30%;*/
  width: 25%;
  height: 100%;
  background-color: #fff;
  float: left;
  overflow: auto;
}
/deep/ .van-sidebar-item {
  text-align: center;
  padding: 15px 12px 15px 8px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}

/deep/ .van-sidebar-item--select {
  color: #fff;
  border-color: #000;
  background-color: #000;
}

/deep/ .van-divider {
  border-width: 2px;
}
/deep/ .van-info {
  border-color: #000;
}
.menuImg {
  vertical-align: middle;
}
.van-button__text {
  color: #fff;
}
.contentWrapper {
  padding-top: 46px;
}
.home {
  width: 100%;
  background-color: #f3f3f3;
}
.menuContent {
  width: 100%;
  height: calc(100vh - 96px);
  flex: auto;
  margin-bottom: 55px;
}
.menuContent1 {
  width: 100%;
  height: calc(100vh - 132px);
  flex: auto;
  /* margin-bottom: 100px; */
}
.dishContent {
  /*width: 70%;*/
  width: 75%;
  height: 100%;
  float: right;
  overflow: auto;
}
.dishItem {
  width: calc(100% - 16px);
  margin: 8px;
  height: 100px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  display: flex;
  overflow: hidden;
}
.itemInfo {
  flex: auto;
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
  width: 100px;
}
.leftInfo {
  margin-left: 5px;
  margin-top: 5px;
  width: calc(100% - 26px);
  min-height: 5rem;
  font-size: 14px;
}
.fontLine {
  height: 20px;
  overflow: hidden;
  word-break: break-all;
}
.icons {
  display: flex;
  position: absolute;
  bottom: 2px;
  right: 5px;
}
.itemIcon {
  text-align: right;
}
.enterIcon {
  position: absolute;
  top: 7px;
  right: 5px;
}
.flexBox {
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.flexNone {
  flex: none;
}
.currentPrice {
  color: #ff6666;
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.cart_left {
  width: 60%;
  height: 34px;
  line-height: 34px;
  float: left;
}
.cart_right {
  width: 40%;
  height: 34px;
  line-height: 34px;
  float: right;
  text-align: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #222;
}
.total_price {
  width: 120px;
  height: 34px;
  line-height: 34px;
  text-indent: 10px;
  font-size: 16px;
  color: #fff;
}
.cartDetail {
  width: 100%;
  height: auto;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  position: relative;
}
.leftdot {
  position: absolute;
  width: 6px;
  height: 6px;
  left: -3.5%;
  top: 15px;
  background: linear-gradient(to right, #ffc914, #ffc813);
  border-radius: 50%;
}
.cart_dish {
  width: 100%;
}
.cart_dish_name {
  width: 80%;
  height: 50px;
  line-height: 50px;
  text-indent: 5px;
}
.cart_dish_icon {
  width: 80%;
  height: 40px;
  line-height: 40px;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.icon_group {
  padding-top: 10px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  clear: both;
}
.realPrice {
  color: #000;
}
.detailBar {
  width: 100%;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #222;
  background-color: #ffc914;
  border-bottom: 1px solid #f3f3f3;
  position: relative;
  /* padding-top: 46px; */
}
.rightIcon {
  position: absolute;
  right: 5px;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/takeAway/TakeDishes.vue